export enum PreselectTemplateKeysEnum {
  REQUEST_LEAD_MAIL = "request_lead_mail",
  REQUEST_CLEARANCE_APPROVAL_MAIL = "request_clearance_approval_mail",
  REQUEST_CLEARANCE_MAIL = "request_clearance_mail",
  REQUEST_REPORT_ATTACHMENT_MAIL = "request_report_attachment_mail",
  REQUEST_REPORT_ATTACHMENT_SMS = "request_report_attachment_sms",
  REQUEST_REPORT_MAIL = "request_report_mail",
  REQUEST_REPORT_SMS = "request_report_sms",
  REQUEST_REPAIR_ESTIMATE_ACCEPT_MAIL = "request_repair_estimate_accept_mail",
  REQUEST_REPAIR_ESTIMATE_MAIL = "request_repair_estimate_mail",
  REQUEST_REPAIR_ESTIMATE_REJECT_MAIL = "request_repair_estimate_reject_mail",
  REQUEST_SIGNATURE_MAIL = "request_signature_mail",
  REQUEST_SNAPSHOT_SIGNATURE_MAIL = "request_snapshot_signature_mail",
  REQUEST_APPRAISAL_MAIL = "request_appraisal_mail",
  CREATE_RENTAL_MAIL = "create_rental_mail",
  UPDATE_RENTAL_MAIL = "update_rental_mail",
  UPDATE_REPORT_STATUS_MAIL = "update_report_status_mail",
  CLAIM_SETTLEMENT_MAIL = "claim_settlement_mail",
  REQUEST_UBA_REVIEW_MAIL = "request_uba_review_mail",
  FLEET_EVENT_MAIL_WITH_VEHICLE = "fleet_event_mail_with_vehicle",
  EVENT_MAIL = "event_mail"
}
